import { FC, memo } from "react";
import { Box } from "@mui/material";

import {
  AdminContentType,
  ADMIN_MENU_ITEMS,
  hasAdminMenuAccess,
} from "../../../pages/home/model/admin-menu-items";

interface AdminContentProps {
  selectedContent: AdminContentType;
  permissions: number[];
}

export const AdminContent: FC<AdminContentProps> = memo(
  ({ selectedContent, permissions }) => {
    if (!hasAdminMenuAccess(permissions, selectedContent)) {
      return (
        <Box flex={1} p={3} sx={{ width: "100%", minWidth: 0, height: "100%" }}>
          Нет доступа к этому разделу
        </Box>
      );
    }

    const menuItem = ADMIN_MENU_ITEMS.find(
      (item) => item.key === selectedContent,
    );

    if (!menuItem) {
      return <Box flex={1}>Контент не найден</Box>;
    }

    const ContentComponent = menuItem.component;
    return (
      <Box
        flex={1}
        sx={{ width: "100%", minWidth: 0, height: "100%", overflow: "auto" }}
      >
        <ContentComponent />
      </Box>
    );
  },
);
